import CheckboxControlled from 'BaseForm/CheckboxControlled';
import Dropdown from 'BaseForm/Dropdown';
import InputFieldHandler from 'BaseForm/InputFieldHandler';
import PillGroup from 'BaseForm/PillGroup';
import QuantityField from 'BaseForm/QuantityField';
import RadioButtonGroup from 'BaseForm/RadioButtonGroup';
import SwitchComponent from 'BaseForm/Switch';
import SwitchControlled from 'BaseForm/SwitchControlled';
import ConsentInfo from 'ExtendedForm/ConsentInfo';
import CountryDropdown from 'ExtendedForm/CountryDropdown';
import DoubleConsentCheckbox from 'ExtendedForm/DoubleConsentCheckbox';
import InterestCodeRadioButton from 'ExtendedForm/InterestCodeRadioButton';
import MultiLinkConsent from 'ExtendedForm/MultiLinkConsent';
import MultiLinkConsentText from 'ExtendedForm/MultiLinkConsentText';
import MultipleConsentCheckbox from 'ExtendedForm/MultipleConsentCheckbox';
import PhoneInput from 'ExtendedForm/PhoneInput/PhoneInput';
import PreferredLanguageDropdown from 'ExtendedForm/PreferredLanguageDropdown';
import PreferredStoreDropdownContainer from 'ExtendedForm/PreferredStoreDropdownContainer';
import ProfileTypeRadioButtonGroup from 'ExtendedForm/ProfileTypeRadioButtonGroup';
import ProfileUpdateOnFieldChange from 'ExtendedForm/ProfileUpdateOnFieldChange';
import ZipCodeInput from 'ExtendedForm/ZipCodeInput';

import {
  Divider,
  LegalText,
  ResetPasswordLink,
  TextWithLink,
  TextWithModal,
  TranslateToInnerHTML
} from 'Common';
import AddressContainer from 'ExtendedForm/Address/AddressContainer';
import ContactMethodsGroupContainer from 'ExtendedForm/ContactMethodsGroupContainer';
import DynamicChildBirthdateContainer from 'ExtendedForm/DynamicChildBirthdateContainer';
import PasswordContainer from 'ExtendedForm/PasswordContainer';
import PasswordInfo from 'ExtendedForm/PasswordInfo';
import UserLoginContainer from 'ExtendedForm/UserLoginContainer';

import DashboardSectionForm from 'Components/Dashboard/DashboardSectionForm';
import HouseholdSection from 'Components/Household/HouseholdSection';
import SignupSection from 'Components/Signup/SignupSection';
import UpgradeSectionForm from '../../Dashboard/UpgradeSectionForm';
import PaidMediaConsentCheckbox from '../PaidMediaConsentCheckbox';
import PreferredStoreDropdownOnSubmit from '../PreferredStoreDropdownOnSubmit';

import PreferredCommunicationFrequency from '../PreferredCommunicationFrequencyDropdown';

// Components that handle one form field only. In yml form configurations;
// field name, label, defaultValues and other component props are found
// at first level (fields[*].componentProps).
export const SimpleInputComponents = {
  Checkbox: CheckboxControlled,
  Switch: SwitchControlled,
  SwitchComponent,
  ConsentInfo,
  CountryDropdown,
  DoubleConsentCheckbox,
  MultiLinkConsent,
  MultiLinkConsentText,
  Dropdown,
  InputField: InputFieldHandler,
  PhoneInput,
  PillGroup,
  PreferredLanguageDropdown,
  PreferredStoreDropdownOnSubmit,
  PaidMediaConsentCheckbox,
  PreferredCommunicationFrequency,
  InterestCodeRadioButton,
  PreferredStoreDropdown: PreferredStoreDropdownContainer,
  ProfileTypeRadioButtonGroup,
  ProfileUpdateOnFieldChange,
  RadioButtonGroup,
  QuantityField,
  MultipleConsentCheckbox,
  ZipCodeInput
};

// Components that handle more than one form field. In yml form configurations;
// field names, labels, defaultValues and other component props are found
// at second level (fields[*].componentsProps.nestedFields[*].componentProps).
export const NestedInputComponents = {
  Address: AddressContainer,
  ContactMethodsGroup: ContactMethodsGroupContainer,
  DynamicChildBirthdate: DynamicChildBirthdateContainer,
  Password: PasswordContainer,
  UserLogin: UserLoginContainer
};

// Components that don't handle any input and are not connected to Redux.
export const StaticComponents = {
  Divider,
  PasswordInfo,
  TextWithModal,
  TranslateToInnerHTML,
  TextWithLink,
  LegalText,
  ResetPasswordLink
};

// Components used for sectionizing the forms.
export const SectionComponents = {
  DashboardSectionForm,
  UpgradeSectionForm,
  HouseholdSection,
  SignupSection
};

export const Components = {
  ...SimpleInputComponents,
  ...NestedInputComponents,
  ...StaticComponents,
  ...SectionComponents
};
